import axios from 'axios';
import { ICrudSearchAction, ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';
import { SERVER_API_URL } from 'app/config/constants';

import { IPricing, defaultValue } from 'app/shared/model/pricing.model';

export const ACTION_TYPES = {
  SEARCH_PRICINGS: 'pricing/SEARCH_PRICINGS',
  FETCH_PRICING_LIST: 'pricing/FETCH_PRICING_LIST',
  FETCH_PRICING: 'pricing/FETCH_PRICING',
  CREATE_PRICING: 'pricing/CREATE_PRICING',
  UPDATE_PRICING: 'pricing/UPDATE_PRICING',
  DELETE_PRICING: 'pricing/DELETE_PRICING',
  RESET: 'pricing/RESET'
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IPricing>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false
};

export type PricingState = Readonly<typeof initialState>;

// Reducer

export default (state: PricingState = initialState, action): PricingState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.SEARCH_PRICINGS):
    case REQUEST(ACTION_TYPES.FETCH_PRICING_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PRICING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_PRICING):
    case REQUEST(ACTION_TYPES.UPDATE_PRICING):
    case REQUEST(ACTION_TYPES.DELETE_PRICING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.SEARCH_PRICINGS):
    case FAILURE(ACTION_TYPES.FETCH_PRICING_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PRICING):
    case FAILURE(ACTION_TYPES.CREATE_PRICING):
    case FAILURE(ACTION_TYPES.UPDATE_PRICING):
    case FAILURE(ACTION_TYPES.DELETE_PRICING):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.SEARCH_PRICINGS):
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_PRICING_LIST):
      return {
        ...state,
        loading: false,
        totalItems: action.payload.headers['x-total-count'],
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_PRICING):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_PRICING):
    case SUCCESS(ACTION_TYPES.UPDATE_PRICING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_PRICING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = SERVER_API_URL + '/api/pricings';
const apiSearchUrl = SERVER_API_URL + '/api/_search/pricings';

// Actions

export const getSearchEntities: ICrudSearchAction<IPricing> = query => ({
  type: ACTION_TYPES.SEARCH_PRICINGS,
  payload: axios.get<IPricing>(`${apiSearchUrl}?query=` + query)
});

export const getEntities: ICrudGetAllAction<IPricing> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_PRICING_LIST,
    payload: axios.get<IPricing>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`)
  };
};

export const getEntity: ICrudGetAction<IPricing> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_PRICING,
    payload: axios.get<IPricing>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IPricing> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PRICING,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IPricing> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PRICING,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IPricing> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_PRICING,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
